import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Store} from "@ngrx/store";
import {
  FetchQuestionnaireDetailsForEditViewRequest
} from "../../core/questionnaires.actions";
import {Subject, takeUntil} from "rxjs";
import {profile} from "../../../../shared/core/shared.selectors";
import {CommonService} from "../../../../shared/services/common.service";

@Component({
  selector: 'app-edit-survey-screen',
  templateUrl: './edit-survey-screen.component.html',
  styleUrls: ['./edit-survey-screen.component.css']
})
export class EditSurveyScreenComponent implements OnInit, OnDestroy {
  selectedTab: number = 0;
  surveyId: string = ''

  loggedInUserRole: number = null;
  groupId: string = ''
  clientId: string = ''
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.store.select(profile).pipe(takeUntil(this.onDestroy))
      .subscribe(profile => {
        if (profile) {
          this.loggedInUserRole = profile.role;
        }
      })

    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        if (params?.params?.questionnaireId) {
          this.surveyId = params?.params?.questionnaireId
          this.store.dispatch(FetchQuestionnaireDetailsForEditViewRequest({
            payload: {
              surveyId: params?.params?.questionnaireId
            }
          }))
          if (params.params.groupId) {
            this.groupId = params.params.groupId
          }
          if (params.params.clientId) {
            this.clientId = params.params.clientId
          }
        }
      });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  setSelectedTab(tabIndex: number) {
    this.selectedTab = tabIndex
  }


  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
